import { PropsWithChildren } from 'react';
import { FormHeading } from './form-heading';
import { FormRuler } from './form-ruler';

type Props = {
  title: string;
  hasBottomBorder?: boolean;
};

export const AvailabilityFormSection = ({ title, children, hasBottomBorder = true }: PropsWithChildren<Props>) => {
  return (
    <>
      <FormHeading>{title}</FormHeading>
      {children}
      {hasBottomBorder && <FormRuler />}
    </>
  );
};
